import { Search } from '@mui/icons-material';
import { Box, TextField } from '@mui/material';
import { StyleObj } from '../../@types';

const styles: StyleObj = {
  wrapper: {
    p: 0,
    backgroundColor: 'background.light',
  },
  field: {
    width: '100%',
  },
};

type MarketsSearchFieldProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
};

const MarketsSearchField = ({ value, onChange, placeholder = 'Search markets' }: MarketsSearchFieldProps) => (
  <Box sx={styles.wrapper}>
    <TextField
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      size='small'
      sx={styles.field}
      slotProps={{
        input: {
          startAdornment: <Search sx={{ mr: 0.5, color: 'action.active' }} />,
        },
      }}
    />
  </Box>
);

export default MarketsSearchField;
